import type { UserMessageType } from '@/type/login';
import { getRequest, postRequest } from '@/utils/request';
import { userInfoTranslator } from '@/utils/translateUserInfo';

// 获取用户信息
export const getUserInfo = () => {
    return getRequest<UserMessageType>('/rbac/user/message', null, {
        showErrorToast: false,
        showHttpError: false,
    }).then((data) => {
        return data ? userInfoTranslator(data) : data;
    });
};

// 退出登录
export const logout = () => {
    return getRequest<boolean>('/rbac/user/loginout');
};

// 根据飞书回调的code获取用户信息
export const getTokenByCode = (params: {
    code?: string;
    appId?: string;
    requestToken?: string;
}) => {
    return getRequest('/rbac/user/feishu/code', params);
};

// 通用数据
export const getCommonData = () => {
    return getRequest<CommonDataType>(
        '/rbac/common/info',
        {
            needInfoList: 'department',
        },
        {
            showErrorToast: false,
            showHttpError: false,
        },
    );
};

// 修改接单装填
export const changeReceiveStatus = (id: number, autoReceiveStatus: number) => {
    return postRequest('/rbac/user/manager/updateAutoReceiveStatus', {
        id,
        autoReceiveStatus,
    });
};
